import AdminLayout from '@/layouts/AdminLayout.vue'

export default [
  {
    path: '/recycler-center-links/:recyclerCenterLinkId',
    name: 'recyclerCenterLinkDetail',
    component: () =>
      import(
        '@/views/restricted/recycling-module/recycler/recycler-center/recycler-center-link/RecyclerCenterLinkDetailLayoutView.vue'
      ),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_RECYCLING_READ'],
      menuSelected: 'recycling'
    }
  },
  {
    path: '/recycler-centers/:recyclerCenterId/links/create',
    name: 'recyclerCenterLinkCreate',
    component: () =>
      import(
        '@/views/restricted/recycling-module/recycler/recycler-center/recycler-center-link/RecyclerCenterLinkCreateView.vue'
      ),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_RECYCLING_CREATE'],
      menuSelected: 'recycling'
    }
  },
  {
    path: '/recycler-center-links/:recyclerCenterLinkId/edit',
    name: 'recyclerCenterLinkUpdate',
    component: () =>
      import(
        '@/views/restricted/recycling-module/recycler/recycler-center/recycler-center-link/RecyclerCenterLinkUpdateView.vue'
      ),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_RECYCLING_UPDATE'],
      menuSelected: 'recycling'
    }
  }
]
